import { Link } from "react-router-dom";

import { ReactTyped } from "react-typed";

const Footer = () => {
    return (
        <div className="mt-10 mb-4 px-5">
            <h1 className="text-[3.5rem] md:text-[10rem] text-pink-400 opacity-35">
                <Link to="mailto:info@sahirprajapati.com">
                    <ReactTyped
                        strings={["Dis bonjour", "Say hi", "Sag hallo", "Sig hej",]}
                        typeSpeed={100}
                        backSpeed={50}
                        loop
                        cursorChar="."
                        showCursor={true}
                    />
                </Link>
            </h1>
            <div className="grid grid-cols-12 mt-5 md:mt-20">
                <div className="col-span-6 md:col-span-3 md:col-start-6 place-content-end">
                    <p className="text-pink-500 text-[2rem]">don't be shy, say hi</p>
                    <br />
                    <Link to="mailto:info@sahirprajapati.com"><p>info@sahirprajapati.com</p></Link>
                    <p>43.4640 -80.5222</p>
                    <br />
                    <p className="hidden md:block">&#169;Sahir Prajapati, 2025</p>
                </div>
                <div className="mt-16 md:mt-0 col-span-6 md:col-span-3 col-start-6 md:col-start-9">
                    <p className="text-pink-500 text-[2rem]">currently,</p>
                    <br />
                    <p>Based out of Ontario, Canada. Feel free to reach out for project collaboration or marketing consultations.</p>
                    <br className="md:hidden block" />
                    <p className="md:hidden block">&#169;Sahir Prajapati, 2025</p>
                </div>
            </div>
            <div className="grid grid-cols-12 mt-10 md:my-8 md:mt-20">
                <div className="col-span-12 md:col-span-3 md:col-start-9 text-gray-500 font-light">
                    <p className="text-center">Website designed and developed by Sahir Prajapati :)</p>
                    {/* Yeta chai yo website kasari banaako wala dekhaaune page ko link pachi */}
                </div>
            </div>
        </div>
    )
}

export default Footer;